'use client';

import { Gauge, Star } from 'lucide-react';
import { Display, Reveal, GlassCard, CountUp } from '../ui';

// TODO(testimonials): all quotes, names and handles are PLACEHOLDER.
const quotes = [
  {
    text: "Reclipt changed how we edit. I don't look for files anymore; I just ask for them.",
    handle: '@alex_vids',
    role: 'Independent Creator',
  },
  {
    text: 'The MomentCards are a game changer for quick previews. I can scan 100 clips in seconds.',
    handle: '@jess_creative',
    role: 'Creative Director',
  },
  {
    text: "Finally, an AI tool that actually understands context. It doesn't just look for words; it looks for the vibe.",
    handle: '@sam_editor',
    role: 'Post-Production Supervisor',
    wide: true,
  },
];

function Stars() {
  return (
    <div className="mb-4 flex gap-1 text-mk-pink">
      {Array.from({ length: 5 }).map((_, i) => (
        <Star key={i} className="h-4 w-4" fill="currentColor" />
      ))}
    </div>
  );
}

export default function TestimonialsSection() {
  return (
    <section id="reviews" className="mx-auto max-w-[1280px] px-6 py-28">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
        {/* Featured stat card */}
        <Reveal className="lg:col-span-1">
          <GlassCard className="flex h-full flex-col justify-center border-mk-pink/20 bg-mk-pink/5 p-10">
            <Gauge className="mb-6 h-14 w-14 text-mk-pink" strokeWidth={1.3} />
            {/* TODO(stat): real measured number. */}
            <Display className="mb-4 flex items-baseline gap-2 text-5xl">
              <CountUp to={4} className="text-mk-ink" /> HRS
              <span className="font-mk-body text-base font-normal lowercase text-mk-muted">
                to
              </span>
              <CountUp to={5} className="text-mk-pink" /> MIN
            </Display>
            <p className="font-mk-body text-lg italic text-mk-muted">
              &ldquo;Reduced search time from 4 hours to 5 minutes across our
              entire seasonal archive.&rdquo;
            </p>
            <p className="mt-6 font-mk-label text-xs font-bold uppercase tracking-[0.18em] text-mk-pink">
              Lead Editor at MediaCo (PLACEHOLDER)
            </p>
          </GlassCard>
        </Reveal>

        {/* Quote grid */}
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:col-span-2">
          {quotes.map((q, i) => (
            <Reveal
              key={q.handle}
              delay={i * 0.08}
              className={q.wide ? 'md:col-span-2' : ''}
            >
              <GlassCard hover className="h-full p-8">
                <Stars />
                <p className="mb-6 font-mk-body text-lg text-mk-ink">
                  &ldquo;{q.text}&rdquo;
                </p>
                <div className="flex items-center gap-3">
                  <div className="flex h-10 w-10 items-center justify-center rounded-full bg-mk-pink/15 font-mk-body text-sm font-bold text-mk-pink">
                    {q.handle.charAt(1).toUpperCase()}
                  </div>
                  <div>
                    <p className="font-mk-body font-bold text-mk-ink">
                      {q.handle}
                    </p>
                    <p className="font-mk-body text-xs text-mk-muted">{q.role}</p>
                  </div>
                </div>
              </GlassCard>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
